// import { AlertColor } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import useTailwindBrand from '../Theme/useTailwindBrand';

const Messages = () => {
  const MySwal = withReactContent(Swal)
  const {brandConfig} = useTailwindBrand()
  const generalMessage = useSelector((state: any) => state.message)
  const mapIcon = (type: any) => {
    switch (type) {
      case "error_auth":
        return "error";
      default:
        return type;
    }
  };
  const dispatch = useDispatch()
  const hideMessage = ()=>{
    dispatch({
      type: 'HIDE_MESSAGE', payload: ""
  })
  }
  useEffect(() => {
    if (generalMessage.type !== "" && generalMessage.type !== "HIDE_MESSAGE") {
      displayMessage(generalMessage.type,generalMessage.message)
      setTimeout(hideMessage, 10000)
    } 
  }, [generalMessage])
  const displayMessage = (type: SweetAlertIcon  | undefined, message:string) => {
    MySwal.fire({
      showConfirmButton: true,
      allowOutsideClick: true,
      confirmButtonColor: brandConfig.colors.primary,
      showClass: {
        popup: 'animate__animated animate__heartBeat'
      },
      hideClass: {
        popup: 'animate__animated animate__backOutDown'
      },
      icon: mapIcon(type),
      title: type === "error" ? "Une erreur est survenue" : type === "warning" ? "Remarque" : "",
      text: message,
    }).then(()=>{
      hideMessage()
    })
    MySwal.getPopup()?.classList.add('shadow-notification-course')
    MySwal.getPopup()?.classList.add('rounded-md')
    MySwal.getPopup()?.classList.add('w-[602px]')
    MySwal.getPopup()?.classList.add('md:p-4')
  }
  return (
    <div>

      {/* <Stack sx={{ width: '100%' }} spacing={2}>
            {type && <Alert severity={type} className='justify-center lg:justify-start'>{message}</Alert>}
            </Stack> */}
    </div>
  );
};

export default Messages;